import React, { useCallback, useState } from 'react'
import { CloseIcon, IconMobileNode, IconRoleNode, IconUserRole, UserNodeIcon } from '../iconSet/IconSet';
import { sourceCustomStyles, targetCustomStyles } from '../workflowCanvas/CustomStyles';
import { UserRoleNodePropsTypes } from './FlowchartTypes';
import { Handle, Position, useReactFlow } from 'reactflow';

const UserRoleNode: React.FC<UserRoleNodePropsTypes> = ({ id, data }) => {
    
    const { deleteElements } = useReactFlow();
    const [isHovering, setIsHovering] = useState(false);

    const handleMouseOver = () => {
        setIsHovering(true);
    };

    const handleMouseOut = () => {
        setIsHovering(false);
    };

    const deleteNode = useCallback(() => {
        console.log(id);
        deleteElements({ nodes: [{ id }] });
    }, [id, deleteElements]);

    return (
        <div className={`user-role-node`} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
            <div className='icon-wrapper' style={{ transform: 'skew(calc(var(--_angle-node) * -1))'}}>
                <IconUserRole width='2rem'/>
            </div>
            
            <span>{data.data.name} - (User Role)</span>
            {isHovering && (
                <div className={`node-close-ico`} onClick={deleteNode}>
                    <CloseIcon width='1rem' color="var(--color-main-red)"/>
                </div>
            )}  
            <Handle id='pdf-target-a' type='target' position={Position.Top} style={{...targetCustomStyles, background: "blue", transform: 'skew(calc(var(--_angle-node) * -1))'}}/>
            <Handle id='pdf-source-a' type='source' position={Position.Bottom} style={{...sourceCustomStyles, background: "yellow", transform: 'skew(calc(var(--_angle-node) * -1))'}}/>
            <Handle id={"pro-source-right"} type="source" position={Position.Right} style={{...sourceCustomStyles, background: "yellow", transform: 'skew(calc(var(--_angle-node) * -1))'}}/>
            <Handle id={"pro-target-left"} type="target" position={Position.Left} style={{...targetCustomStyles, background: "blue", transform: 'skew(calc(var(--_angle-node) * -1))'}}/>
        </div>
    );
};

export default UserRoleNode;